export default [
  {
    id: 'profile',
    title: 'プロフィール',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '住所',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '連絡先',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'id-photo',
    title: '証明写真',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-history',
    title: '学歴',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'license-history',
    title: '免許・資格',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'reasonNew',
    title: '自己PR',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'others',
    title: '通勤時間ほか',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'requests',
    title: '本人希望欄',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'create-date',
    title: '作成日',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'output',
    title: 'ダウンロード',
    previewJumpId: 'close-preview-button-above'
  }
]
